import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Обновляем состояние, чтобы при следующем рендеринге показать запасной UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Логируем ошибку в консоль, но не показываем пользователю
    console.error("Caught error:", error);
    console.error("Component stack:", errorInfo.componentStack);
    
    // Здесь можно добавить отправку ошибки в аналитику или мониторинг
    // if (typeof window !== 'undefined' && window.errorReportingService) {
    //   window.errorReportingService.report(error, errorInfo);
    // }
  }

  render() {
    if (this.state.hasError) {
      // Возвращаем минимальный UI без технических деталей
      return (
        <div className="p-8 text-center">
          <div className="p-4 rounded-md bg-white border border-gray-200">
            <img 
              src="/placeholder-icon.png" 
              width="64" 
              height="64" 
              alt="Icon"
              className="mx-auto mb-4" 
            />
            <p className="text-lg mb-4">Не удалось загрузить иконку</p>
            <button
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              onClick={() => {
                if (typeof window !== 'undefined') {
                  // Добавляем параметр для сброса кэша
                  const url = new URL(window.location.href);
                  url.searchParams.set('reload', Date.now());
                  window.location.href = url.toString();
                }
              }}
            >
              Повторить
            </button>
          </div>
        </div>
      );
    }

    // Если ошибки нет, рендерим дочерние компоненты как обычно
    return this.props.children;
  }
}

export default ErrorBoundary;